<template>
  <div>
    <Row>
      <Form ref="queryCarRuleForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label-width="0">
          <Input
            v-model="query.plateNo"
            placeholder="请输入车牌号"
            style="width:170px;margin-right: 10px;"
          />

            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openCarRuleDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="carRuleTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.carRuleTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="carRuleDrawer" :title="this.$t('drawer.title')[carRuleDrawer.type]" :visible.sync="carRuleDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <carRule-form ref="carRuleForm"/>
        <div class="right-drawer__footer" v-if="carRuleDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="carRuleDrawer.submiting">{{ carRuleDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="carRuleDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import CarRuleForm from '@/views/travel/car-rule/components/Form.vue';
Vue.component('carRule-form', CarRuleForm);

export default {
  name: 'aip-travel-carRule-index',
  mixins:[mixin],
  data () {
    return {
      query:{
        plateNo:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      carRuleDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'batchDel',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.travel.CarRule.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openCarRuleDrawer(carRule){
      this.carRuleDrawer.visible = true
      this.carRuleDrawer.type = carRule ? carRule.type : 'add'
      this.$nextTick(()=>{
          if(carRule){
              this.$refs['carRuleForm'].getCarRule(carRule.id,carRule.type)
          }else{
            this.$refs['carRuleForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.carRuleDrawer.submiting = true;
        this.$refs.carRuleForm.handleSubmit(
          data=>{
            this.carRuleDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.carRuleDrawer.visible=false, 1000);
          },
          ()=>{
            this.carRuleDrawer.submiting = false;
          }
        )
    },
    deleteCarRule(id){
      api.travel.CarRule.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.travel.CarRule.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    },
    handleBatchOperate(){
      let records = this.$refs.carRuleTable.getSelection()
      if (records.length == 0) {
        this.$Message.warning(this.$t('errorText'))
        return;
      }
      this[this.batchOperate.action](records)
    }
  },
  computed: {
    columns () {
      return [
          {key: 'id', width: 60, fixed:'left',type:'selection'},

          {key: 'plateNo', align:'left',width: 120,fixed:'left', title:  this.$t('travel.car-rule.plateNo.label')},
          {key: 'rule', align:'left', title:  this.$t('travel.car-rule.rule.label')},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openCarRuleDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openCarRuleDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteCarRule(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
